export default __webpack_public_path__ + "static/media/logo_login.b240b484.png";